export const SUPPORTED_LEAUGUES = ['NBA, NFL'];

export const NO_GAMES_MESSAGE = 'No Games Scheduled';
